export default "__VITE_ASSET__DMz$FIHc__"